import React from 'react';
import {
  MixedWidget1,
  MixedWidget14,
  ListsWidget9,
  StatsWidget11,
  StatsWidget12,
  ListsWidget1,
  AdvanceTablesWidget2,
  AdvanceTablesWidget4,
  ListsWidget3,
  ListsWidget4,
  ListsWidget8,
  TilesWidget11,
  TilesWidget1,
  TilesWidget2,
} from '../widgets';
import axios, { baseUrl } from '../../../redux/my-axios';

export const Dashboard = () => {
  return (
    <>
      <div className='row'>
        <div className='col-lg-2 col-xxl-2'>
          <div>
            <TilesWidget11
              baseColor='primary'
              widgetHeight='150px'
              className='card-stretch card-stretch-half gutter-b'
              target='MERCHANT'
              type='PRODUCT_COUNT'
              freq='TOTAL'
              title='БҮТЭЭГДЭХҮҮН'
              icon='/media/svg/icons/Home/Home.svg'
            />
          </div>
          <div>
            <TilesWidget11
              className='card-stretch card-stretch-half gutter-b'
              baseColor='success'
              widgetHeight='150px'
              target='MERCHANT'
              type='ORDER_COUNT'
              freq='FIXED_MONTHLY'
              title='ЗАХИАЛГА'
              icon='/media/svg/icons/Shopping/Cart2.svg'
            />
          </div>
          <div>
            <TilesWidget11
              className='card-stretch card-stretch-half gutter-b'
              baseColor='info'
              widgetHeight='150px'
              target='MERCHANT'
              type='DELIVER_COUNT'
              freq='FIXED_MONTHLY'
              title='ХҮРГЭЛТ'
              icon='/media/svg/icons/Shopping/Gift.svg'
            />
          </div>
        </div>
        <div className='col-lg-5 col-xxl-5'>
          <div>
            <TilesWidget1
              baseColor='light'
              className='card-stretch card-stretch-half gutter-b'
              target='MERCHANT'
              type='SALES_COUNT'
              freq='MONTHLY'
              freqFrom='DAILY'
              title='БОРЛУУЛАЛТЫН ТОО'
              icon='/media/svg/icons/Layout/Layout-4-blocks.svg'
            />
            <TilesWidget2
              baseColor='success'
              className='card-stretch card-stretch-half gutter-b'
              target='MERCHANT'
              type='SALES_AMOUNT'
              freq='MONTHLY'
              freqFrom='DAILY'
              title='БОРЛУУЛАЛТЫН ДҮН'
              icon='/media/svg/icons/Layout/Layout-4-blocks.svg'
            />
          </div>
        </div>
        <div className='col-lg-5 col-xxl-5'>
          <AdvanceTablesWidget2
            className='card-stretch gutter-b'
            target='MERCHANT'
            type='TOP_SOLD_PRODUCTS'
            freq='DAILY'
            freqFrom='DAILY'
            title='БОРЛУУЛАЛТЫН ДҮН'
          />
        </div>
      </div>
    </>
  );
};
